import { render, staticRenderFns } from "./ModalRegister.vue?vue&type=template&id=49716a3e&"
import script from "./ModalRegister.vue?vue&type=script&lang=js&"
export * from "./ModalRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports